import React, { Component } from 'react';
import PhoneVerificationModal from '../../PhoneVerificationModal/PhoneVerificationModal';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { loadAccount } from '../../../actions/account';
import bt from '../../commonStyle.css';
import messages from '../../../locale/messages';


class PhoneVerification extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}
	async handleClick() {
		const { nextPage, loadAccount, account } = this.props;
		await loadAccount();
		if (!account.verification.isIdVerification) {
			nextPage('dniVerification')
		} else {
			nextPage('payment');
		}
	}

	render() {
		return (
			<div>
				<h3 className={'textWhite'}>
					<FormattedMessage {...messages.phoneVerification} />
				</h3>
				<PhoneVerificationModal onVerified={this.handleClick} />
			</div>
		);
	}
}

const mapState = (state) => ({
	account: state.account.data,
});

const mapDispatch = {
	loadAccount
};

export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(PhoneVerification)));